import './Pagination.css';
import React from "react";
import ReactPaginate from "react-paginate";

const Leyend = ({pagedData}) => {
    const calc = (pd) => pd.hasNextPage ? pd.limit * pd.page : pd.pagingCounter;

    const ini = pagedData.totalDocs > 0 ? pagedData.pagingCounter : 0;
    const fin = pagedData.totalDocs > 0 ? calc(pagedData) : 0;

    return (<>Mostrando {ini} a {fin} de {pagedData.totalDocs} registros</>);
}

function Pagination({pagedData, onPageChange, forcePage}) {
    return (
        <div className="row">
            <div className=" col-sm-5 col-4">
                <Leyend pagedData={pagedData}/>
            </div>
            <div className=" col-sm-7 col-8">
                <ReactPaginate
                    pageCount={pagedData.totalPages}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={2}
                    previousLabel="&laquo;"
                    nextLabel="&raquo;"
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    onPageChange={onPageChange}
                    forcePage={forcePage}
                    containerClassName={"pagination pagination-sm justify-content-end"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    activeClassName={"active"}
                    previousClassName={"page-item"}
                    nextClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                />
            </div>
        </div>
    );
}

export default Pagination;